export enum EImagerType {
  Unknown,
  RI360_VISUV,
  RI1000_VISUV,
  RI360_VIS,
  RI360_SLP,
  RI360_MFI,
}
